import { useState } from "react";
function useNewReactModal() {
    const[modalIsOpen, setIsOpen] = useState(false);
    

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    return { modalIsOpen, openModal, closeModal, setIsOpen };
}

export default useNewReactModal;